import _ from 'lodash';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { first, map, takeUntil } from 'rxjs/operators';
import { MerchandiseFormSchema } from 'app/campaign/structure/merchandise';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbpInputComponent } from '../../mdb-input/mdb-input.component';
import { MdbTextareaComponent } from '../../mdb-textarea/mdb-textarea.component';
import { IconDeleteComponent } from 'app/icon/components/icon-delete/icon-delete.component';
import { QuillCustomComponent } from '../../quill-custom/quill-custom.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { ChipsComponent } from '../../chips/chips.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbSwitchComponent } from '../../mdb-switch/mdb-switch.component';

@Component({
  standalone: true,
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbpInputComponent,
    MdbTextareaComponent,
    IconDeleteComponent,
    InputMaskModule,
    NgxCurrencyDirective,
    QuillCustomComponent,
    MdbAutocompleteModule,
    ChipsComponent,
    MdbSelectModule,
    MdbSwitchComponent,
  ],
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit, OnDestroy {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public types = [{
    id: 1,
    label: 'Text'
  }, {
    id: 2,
    label: 'Selection - to be selection from options'
  }, {
    id: 3,
    label: 'Street Address'
  }, {
    id: 4,
    label: 'Phone Number'
  }];

  public option: UntypedFormGroup = null;
  public optionsControl: UntypedFormControl = null;

  public takeUntilSubject: Subject<any> = new Subject();
  
  constructor(
    private store: Store,
    private formBuilder: UntypedFormBuilder,
    private campaignService: CampaignService,
    private dialogService: DialogService,
  ) { 
    this.option = this.formBuilder.group({});
    this.campaignService.generateForm(this.option, MerchandiseFormSchema);

    this.dialog$.pipe(
      first(),
      map(({ initialState }) => _.cloneDeep(initialState)),
      takeUntil(this.takeUntilSubject)
    ).subscribe((initialState) => {
      const option = _.get(initialState, 'option', null);
      if(option) {
        option.optional = !option.optional;
        this.campaignService.initializeForm(this.option, option, MerchandiseFormSchema);
      }
    });
  }

  ngOnInit(): void {
    this.optionsControl = this.option.get('options') as UntypedFormControl;

    this.campaignService.configGroup(this.option, this.option, {
      name: 'type',
      value: 2
    }, [
      { name: 'options', defaultValue: [], validators: [Validators.required] }
    ], this.takeUntilSubject);
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.dialogService.closeDialogSubject.next(null);
  }

  close(dialog, value) {
    const { initialState: { id, action } } = dialog;
    this.dialogService.closeDialogSubject.next({ id, action, name: 'formField', value });
  }
  
  confirm(dialog, value) {
    if(this.option.invalid) {
      return this.option.markAllAsTouched();
    }
    value.optional = !value.optional;
    return this.close(dialog, value);
  }
}
